import {AddCooperationOfferFormField, UsernameData} from "../types/add-cooperation-offer.types";
import {Validators} from "@angular/forms";

export const addCooperationOfferModalName = 'add-cooperation-offer';

export const defaultUsernameData: UsernameData = {
  username: null,
  rawUsername: null
}

export const addCooperationOfferFormFields: Array<AddCooperationOfferFormField> = [
  {
    fieldName: 'id',
    label: '',
    hidden: true
  },
  {
    fieldName: "channelUrl",
    label: 'Ссылка где размещаем рекламу',
    validators: [ Validators.required ]
  },
  {
    fieldName: "displayedChannelName",
    label: 'Отображаемое имя канала',
  },
  {
    fieldName: "channelName",
    label: 'Имя канала',
    validators: [ Validators.required ]
  },
]
